export default "__VITE_ASSET__717fc7b3__"